<template>
    <table class="table table-bordered border-secondary">
        <tbody>
            <tr><th class="bgAlma text-white" scope="col">{{ indicatore.Ordinatore__c}}. {{ indicatore.Descrizione__c }}</th></tr>
            <tr>
                <td>
                    <div>
                        <div class="col" :class="{'pe-0' : localVoto < 0 }">
                            <select class="form-select rounded-pill py-0" v-model="localVoto"
                            @change="handleChange"
                            :class="{'bg-danger bg-opacity-25 border-danger text-danger' : localVoto < 0 && !indicatore.Opzionale__c}">
                                <option disabled :value="-1">{{ indicatore.Descrizione__c }}</option>
                                <option v-for="v in voti_in(indicatore.Valutazione_in__c)" :key="v">{{ v }}</option>
                            </select>
                        </div>
                    </div>
                    <input v-if="localVoto > -1 && localVoto < 18 && !indicatore.Opzionale__c" placeholder="Note"
                        class="mt-2 border" :class="{'border-danger bg-danger bg-opacity-25' : !localCommento}"
                        v-model="localCommento" type="text"
                        @input="handleChange">
                </td>
            </tr>
        </tbody>
    </table>
</template>
 
 
<script>
export default {
    Descrizione__c: 'votoEsame',
    components: {},
    props: {
        indicatore: Object,
        voto: Number,
        commento: String,
    },
    data() {
        return {
            localVoto: this.voto,
            localCommento: this.commento
        }
    },
    computed: {},
    mounted () {},
    created() {},
    watch: {
        voto(newVal) {
            this.localVoto = newVal
        }
    },
    methods: {
        voti_in(num) {
            return Array.from({length: num + 1}, (_, i) => num - i)
        },
        handleChange() {
            this.$emit('saveVotiIndicatoriEsame', { 
                indicatore: this.indicatore.Descrizione__c, 
                voto: Number(this.localVoto),
                commento: this.localCommento
            })
        }
    }
}
</script>